import { render, staticRenderFns } from "./MaxCommentsCard.vue?vue&type=template&id=468ca3a6&scoped=true"
import script from "./MaxCommentsCard.vue?vue&type=script&lang=ts"
export * from "./MaxCommentsCard.vue?vue&type=script&lang=ts"
import style0 from "./MaxCommentsCard.vue?vue&type=style&index=0&id=468ca3a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468ca3a6",
  null
  
)

export default component.exports